export default "__VITE_ASSET__CuHiIJqs__"